<script>
export default {
  props: {
    tabList: Array,
    tabWidth: {
      default: "100%",
      type: String
    },
    borderColor: {
      default: "#00c1de",
      type: String
    },
    textColor: {
      default: "#00c1de",
      type: String
    }
  },
  data() {
    console.log(">>>>>", this.tabList);
    let checkList = [];
    if (this.tabList && this.tabList.length > 0) {
      checkList = [this.tabList[0].key];
    }
    console.log("item.key", checkList);
    return {
      checkList
    };
  },
  methods: {
    onSwitch(tab) {
      //   this.$refs["form"].resetFields();
      //   const goalTab = this.tabs.filter(o => o.key === tab)[0];
      this.checkList = [tab];
      console.log('tab', tab)
      this.$emit('switchTab', tab)
    }
  }
};
</script>

<template>
  <div class="gameIntroduceTabs" :style="{'width': tabWidth }">
    <div class="detailTabs">
      <div
        v-for="item in tabList"
        :key="item.key"
        class="tab-cell"
        @click="onSwitch(item.key)"
        :style="{'border-bottom': `${checkList.indexOf(item.key) > -1 ? `2px solid ${borderColor}`: '0px solid #E8E8E8'}`, 'color': `${checkList.indexOf(item.key) > -1 ? textColor : '#595959'}`}"
      >{{item.label}}</div>
    </div>
    <slot></slot>
  </div>
</template>

<style lang="scss">
.gameIntroduceTabs {
  .detailTabs {
    background-color: #ffffff;
    margin-left: 2%;
    margin-right: 2%;
    width: 96%;
    display: inline-block;
    border-bottom: 1px solid #e8e8e8;
    .tab-cell {
      display: inline-block;
      padding: 20px;
      text-align: center;
      // width: 120px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// yotta-vue-components/vision/gameIntroduceTabs.vue